import React, { useRef } from 'react';
// import { RouterHistory } from 'react-router-dom';
import { maybe, MaybeWrapper } from '@lwtears/lwt-common-frontend/lib/@common/util';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import BookLayout from './BookLayout';
import FooterActions from './FooterActions';
import ZoomControls from './ZoomControls';
import SvgIconButton from '../../../common/SvgIconButton';
import { NavigationButtonProps } from '../../../../components/activities/ArrowNavigationButton';
import usePage from '../../../../hooks/use-page';
import useZoomAutoScroll from '../../../../util/hooks/use-zoom-auto-scroll';
import NavigationControl from './NavigationControl';
import HintButton from './HintButton';

interface Props {
  // history?: RouterHistory;
  children: any;
  displayZoomControls?: boolean;
  onePageBehavior?: boolean;
  pagination?: boolean;
  handleContinue?: any;
  hasFooter?: boolean;
  bookLayout?: boolean;
  gameLayout?: boolean;
  isMainPage?: boolean;
  hasCover?: boolean;
  hasHint?: boolean;
  height?: string;
  ArrowNavigationButton?: React.FC<NavigationButtonProps>;
}
const MaybeBookLayout = MaybeWrapper<any>(BookLayout);
const MainActivityPagingControls: React.FC<Props> = ({
  children,
  handleContinue,
  pagination,
  hasFooter,
  bookLayout = true,
  gameLayout = false,
  isMainPage,
  hasCover = false,
  hasHint = false,
  ArrowNavigationButton = SvgIconButton,
  height = '100%',
  ...props
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const bookRef = useRef<HTMLDivElement>(null);

  const [{ currentPage, zoomed }] = usePage();

  useZoomAutoScroll(currentPage, containerRef, bookRef);

  const determineMargins = () => {
    let margin = '30px 60px';
    let largeScreenMargin = '34px 60px';

    if (hasFooter && !isMainPage) {
      margin = '12px 60px';
      largeScreenMargin = '12px 60px';
    }
    if (!hasFooter && isMainPage) {
      margin = '100px 60px';
      largeScreenMargin = '60px';
    }
    return {
      margin,
      largeScreenMargin,
    };
  };

  const { margin, largeScreenMargin } = determineMargins();
  const classes = useStyles({ margin, largeScreenMargin, height });

  const MaybeZoomControls = maybe(ZoomControls);
  const MaybeHint = maybe(HintButton);

  return (
    <>
      <NavigationControl
        hasCover={hasCover}
        ArrowNavigationButton={ArrowNavigationButton}
        handleContinue={handleContinue}
      />
      <div
        className={`${classes.container} ${zoomed ? classes.zoomedContainer : ''}`}
        ref={containerRef}
      >
        <MaybeBookLayout
          shouldRender={bookLayout}
          gameLayout={gameLayout}
          pagination={pagination}
          bookRef={bookRef}
          {...props}
        >
          {children}
        </MaybeBookLayout>
        <FooterActions>
          <MaybeHint shouldRender={hasHint} />
          <MaybeZoomControls shouldRender={!!props.displayZoomControls} />
        </FooterActions>
      </div>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  container: (props: any) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: props.margin,
    overflow: 'hidden',
    height: props.height,
    [theme.breakpoints.up('xl')]: {
      margin: props.largeScreenMargin,
    },
  }),
  zoomedContainer: {
    overflow: 'auto !important',
  },
}));

export default MainActivityPagingControls;
